import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import { TeacherBooks } from "./TeacherBooks";
import Api from "utils/api/Api";

export const TopicLatest = ()=>{
    const { school } = useParams();
    const [ openBookList, setOpenBookList ] = useState(false);

    const { data:topic } = useQuery({
      queryKey:['donghwa/latest'],
      queryFn:()=>Api.get('/api/dongwha/topic/latest'),
      staleTime: 1000 * 60 * 60,
    });

    // 동화서당이 없거나..
    // 최신을 못가져오는 상황은 없나?
  
    return (
        <>
        <div className="visual">
          <div className="inner">
            <h2 className="title">동화 서당</h2>
            <h3 className="sub_title">{topic?.data?.teacherUser.name} 훈장님의 {topic?.data?.title}<br/><span>{topic?.data?.subTitle}</span></h3>
            <p className="desc">훈장님께 올바른 글쓰기 방법을 배우고 상상력을 키워보세요.</p> 
            <div className="item_btn">
              <Link to={`/${school}/donghwa/${topic?.data?.id}`} className="btn _square _blue">동화 서당 참여하기</Link>
              <button type="button" className="btn _square _border _border_blue" onClick={e=>setOpenBookList(!openBookList)}>작가님 작품 보기</button>
            </div>
          </div>
        </div>
        {  openBookList && <TeacherBooks teacherName={topic?.data?.teacherUser.name} teacherId={topic?.data?.teacherId} />}
        </>
    )


}